import React, { useState, useEffect, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Collapse from '@material-ui/core/Collapse';
import { mask } from 'remask';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import * as yup from 'yup';
import { cnpj as validateCnpj } from 'cpf-cnpj-validator'; // for everything
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Modal from '@material-ui/core/Modal';
import ListOfCompany from '../../components/ListOfCompany';
import ListOfUsers from '../../components/ListOfUsers';
import { instanceAxios } from '../../InstanceAxios';
import DropZone from '../../components/DropZone';
import { XMEI_PRIMARY_COLOR, UFS } from '../../consts/common';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20,
  },
}));

export default function CadastrarEmpresaUsuario() {
  const cnaePattern = ['99.99-9-99'];
  const unmaskCnae = ['9999999'];
  const CNPJPattern = ['99.999.999/9999-99'];
  const unmaskCNPJ = ['99999999999999'];
  const CEPPattern = ['99.999-999'];
  const unmaskCEP = ['99999999'];
  const [tipoEmpresa, setTipoEmpresa] = useState('');
  const [tipoTributacao, setTipoTributacao] = useState('');
  const [razaoSocial, setRazaoSocial] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [codigoSimples, setCodigoSimples] = useState('');
  const [cep, setCep] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [arrayWithUsers, setArrayWithUsers] = useState([]);
  const [arrayTipoEmpresa, setArrayTipoEmpresa] = useState([]);
  const [arrayTipoTributacao, setArrayTipoTributacao] = useState([]);
  const [errorCnpj, setErrorCNPJ] = useState(false);
  const [errorMessageCnpj, setErrorMessageCNPJ] = useState(false);
  const [tipoEmpresaError, setErrorTipoEmpresa] = useState(false);
  const [tipoTributacaoError, setErrorTipoTributacao] = useState(false);
  const [razaoSocialError, setErrorRazaoSocial] = useState(false);
  const [cepError, setErrorCep] = useState(false);
  const [logradouroError, setErrorLogradouro] = useState(false);
  const [numeroError, setErrorNumero] = useState(false);
  const [complementoError, setErrorComplemento] = useState(false);
  const [bairroError, setErrorBairro] = useState(false);
  const [estadoError, setErrorEstado] = useState(false);
  const [cidadeError, setErrorCidade] = useState(false);
  const [nomesUsuarios, setNomeUsuarios] = useState([]);
  const [idUsuario, setIdUsuario] = useState(0);
  const [idEmpresa, setIdEmpresa] = useState(0);
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [nomeEmpresa, setNomeEmpresa] = useState('');
  const [idUsuarioError, setIdUsuarioError] = useState(false);
  const [idTipoEmpresa, setIdTipoEmpresa] = useState('');
  const [idTipoTributacao, setIdTipoTributacao] = useState('');
  const [abrirAlert, setAlert] = useState(false);
  const [mensagemAlert, setMensagemAlerta] = useState('');
  const [tipoAlerta, setTipoAlerta] = useState('success');
  const [cnae, setCNAE] = useState('');
  const [cnaeError, setErrorCNAE] = useState(false);
  const [messageCNAE, setMessageCNAEInvalido] = useState('');
  const [modalAddFile, setModalAddFile] = useState(false);
  const [fileName, setFileName] = useState('');
  const [fileCertificado, setCertificado] = useState('');
  const [senhaCertificado, setSenhaCertificado] = useState('');
  const [idCertificado, setIdCertificado] = useState('');
  const [linkCertificado, setLinkCertificado] = useState(null);
  const [hasEditAccess, setHasEditAccess] = useState(false);

  const classes = useStyles();

  const schema = yup.object().shape({
    cnpjInput: yup
      .string()
      .required('CNPJ')
      .test('validate', 'CNPJInvalido', () => {
        if (!cnpj) {
          return false;
        }
        return validateCnpj.isValid(mask(cnpj, unmaskCNPJ));
      }),
    razaoSocialInput: yup.string().required('RazaoSocial'),
    tipoEmpresaInput: yup.string().required('TipoEmpresa'),
    tipoTributacaoInput: yup.string().required('TipoTributacao'),
    cepInput: yup.string().required('CEP'),
    logradouroInput: yup.string().required('Logradouro'),
    numeroInput: yup.string().required('Numero'),
    complementoInput: yup.string().required('Complemento'),
    bairroInput: yup.string().required('Bairro'),
    cidadeInput: yup.string().required('Cidade'),
    estadoInput: yup.string().required('Estado'),
    idUsuarioInput: yup.number().min(1, 'IdUsuario'),
    cnae: yup
      .string()
      .required('CNAE')
      .test('length', 'CNAEInvalido', () => {
        if (!cnae) {
          return false;
        }
        return !(cnae.length < 10);
      }),
  });

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const setMessageError = (error) => {
    const obj = {
      CNPJ: () => setErrorCNPJ(true),
      CNPJInvalido: () => {
        setErrorCNPJ(true);
        setErrorMessageCNPJ('CNPJ Inválido.');
      },
      RazaoSocial: () => setErrorRazaoSocial(true),
      TipoEmpresa: () => setErrorTipoEmpresa(true),
      TipoTributacao: () => setErrorTipoTributacao(true),
      CEP: () => setErrorCep(true),
      Logradouro: () => setErrorLogradouro(true),
      Numero: () => setErrorNumero(true),
      Complemento: () => setErrorComplemento(true),
      Bairro: () => setErrorBairro(true),
      Cidade: () => setErrorCidade(true),
      Estado: () => setErrorEstado(true),
      IdUsuario: () => setIdUsuarioError(true),
      CNAE: () => setErrorCNAE(true),
      CNAEInvalido: () => {
        setErrorCNAE(true);
        setMessageCNAEInvalido('CNAE consiste em 7 dígitos.');
      },
    };

    obj[error]?.();
  };

  const clearMessageErrors = () => {
    setErrorCNPJ(false);
    setErrorRazaoSocial(false);
    setErrorTipoEmpresa(false);
    setErrorTipoTributacao(false);
    setErrorCep(false);
    setErrorLogradouro(false);
    setErrorNumero(false);
    setErrorComplemento(false);
    setErrorBairro(false);
    setErrorCidade(false);
    setErrorEstado(false);
    setIdUsuarioError(false);
    setErrorCNAE(false);
    setMessageCNAEInvalido('');
    setErrorMessageCNPJ('');
  };

  const clearInputs = () => {
    setRazaoSocial('');
    setCnpj('');
    setTipoEmpresa('');
    setTipoTributacao('');
    setCep('');
    setLogradouro('');
    setCidade('');
    setEstado('');
    setComplemento('');
    setBairro('');
    setNumero('');
    setCodigoSimples('');
    setNomeUsuario('');
    setCNAE('');
    setCertificado(false);
    setFileName('');
    setCertificado('');
    setIdCertificado('');
    setSenhaCertificado('');
  };

  const handleSubmit = () => {
    setTipoAlerta('success');
    if (!idCertificado && (fileCertificado || senhaCertificado)) {
      if (!fileCertificado || !senhaCertificado) {
        setAlert(true);
        setTipoAlerta('error');
        setMensagemAlerta('Confira dados do certificado do usuário.');
        return;
      }
    } else if (idCertificado && (!fileCertificado || !senhaCertificado)) {
      setAlert(true);
      setTipoAlerta('error');
      setMensagemAlerta('Confira dados do certificado do usuário.');
      return;
    }
    schema
      .validate(
        {
          cnpjInput: cnpj,
          razaoSocialInput: razaoSocial,
          tipoEmpresaInput: tipoEmpresa,
          tipoTributacaoInput: tipoTributacao,
          cepInput: cep,
          logradouroInput: logradouro,
          numeroInput: numero,
          complementoInput: complemento,
          bairroInput: bairro,
          cidadeInput: cidade,
          estadoInput: estado,
          idUsuarioInput: idUsuario,
          cnae: mask(cnae, unmaskCnae),
        },
        { abortEarly: false }
      )
      .then(async (data) => {
        clearMessageErrors();
        const objCompany = {
          id: idEmpresa || null,
          id_usuario: idUsuario,
          tipo_empresa: idTipoEmpresa,
          tipo_tributacao: idTipoTributacao,
          razao_social: razaoSocial,
          cnpj: mask(cnpj, unmaskCNPJ),
          cep: mask(cep, unmaskCEP),
          logradouro,
          numero,
          complemento,
          bairro,
          cidade,
          estado,
          codigo_simples: codigoSimples,
          cnae: mask(cnae, unmaskCnae),
          origem: 'portal',
        };

        await instanceAxios(localStorage.getItem('toobiauth'))
          .post('/empresas', {
            ...objCompany,
          })
          .then(async (result) => {
            if (fileCertificado && typeof fileCertificado === 'object') {
              const data = new FormData();
              data.append('files', fileCertificado);
              data.append('senha', senhaCertificado);
              data.append('id', idCertificado);
              data.append('nomeArquivo', fileName);
              data.append('idEmpresa', result.data.company.id);
              await instanceAxios(localStorage.getItem('toobiauth'))
                .post('/uploadCertificadoDigital', data)
                .then((res) => {
                  setAlert(true);
                  setMensagemAlerta(result.data.message);
                  setNomeEmpresa('');
                  clearInputs();
                })
                .catch((err) => {
                  setAlert(true);
                  setTipoAlerta('error');
                  setMensagemAlerta(err.response.data.message);
                });
            } else {
              setAlert(true);
              setMensagemAlerta(result.data.message);
              setNomeEmpresa('');
              clearInputs();
            }
          })
          .catch((err) => {
            setAlert(true);
            setTipoAlerta('error');
            if (err?.response?.data?.message) {
              setMensagemAlerta(err.response.data.message);
              return;
            }
            setMensagemAlerta(
              'Não foi possivel realizar inserção, tente novamente mais tarde.'
            );
          });
      })
      .catch((err) => {
        clearMessageErrors();
        const validationErrors = Array.isArray(err?.errors) ? err.errors : [];

        validationErrors.forEach((error) => {
          setMessageError(error);
        });
        // setLoading(false);
      });
  };

  const handleCEP = async (value) => {
    await axios
      .get(`https://viacep.com.br/ws/${mask(value, unmaskCEP)}/json/`)
      .then((res) => {
        setLogradouro(res.data.logradouro);
        setComplemento(res.data.complemento);
        setBairro(res.data.bairro);
        setCidade(res.data.localidade);
        setEstado(res.data.uf);
      })
      .catch((err) => {});
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setAlert(false);
  };

  useEffect(() => {
    const fetchDataSelects = async () => {
      await instanceAxios('')
        .get('/tiposEmpresaTributacao')
        .then((res) => {
          setArrayTipoEmpresa(
            Array.isArray(res?.data?.tipoEmpresa) ? res.data.tipoEmpresa : []
          );
          setArrayTipoTributacao(
            Array.isArray(res?.data?.tipoTributacao)
              ? res.data.tipoTributacao
              : []
          );
        });
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get('/meuperfil')
        .then((res) => {
          setHasEditAccess(res.data.id_perfil === 10);
        });
    };
    fetchDataSelects();
  }, []); //eslint-disable-line

  const fetchDataCompany = async (data) => {
    if (
      !arrayWithUsers.some(
        (item) => item.nome === data.UsuarioEmpresa.User.nome
      )
    ) {
      const array = [
        ...arrayWithUsers,
        {
          id: data.UsuarioEmpresa.User.id,
          nome: data.UsuarioEmpresa.User.nome,
          cpf: data.UsuarioEmpresa.User.cpf,
          cnpj: data.cnpj,
        },
      ];
      setArrayWithUsers(array);
    }

    setRazaoSocial(data.razao_social);
    setNomeUsuario(data.UsuarioEmpresa.User.nome);
    setIdUsuario(data.UsuarioEmpresa.User.id);
    setCnpj(mask(data.cnpj, CNPJPattern));
    const nomeTipoEmpresa = arrayTipoEmpresa.find(
      (tipo) => tipo.id === data.tipo_empresa
    );
    setTipoEmpresa(nomeTipoEmpresa?.nome || '');
    setIdTipoEmpresa(nomeTipoEmpresa?.id || '');
    const nomeTipoTributacao = arrayTipoTributacao.find(
      (tipo) => tipo.id == data.tipo_tributacao
    );
    setTipoTributacao(nomeTipoTributacao?.nome || '');
    setIdTipoTributacao(nomeTipoTributacao?.id || '');
    setCep(mask(data.cep, CEPPattern));
    setLogradouro(data.logradouro);
    setNumero(data.numero);
    setCidade(data.cidade);
    setEstado(data.estado);
    setBairro(data.bairro);
    setComplemento(data.complemento);
    setCNAE(mask(data.cnae, cnaePattern));
    setCodigoSimples(data.codigo_simples);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/certificadoDigital/${data.id}`)
      .then((res) => {
        if (res.data) {
          setCertificado(true);
          setFileName(res.data.nome_arquivo);
          setIdCertificado(res.data.id);
          setSenhaCertificado(res.data.senha);
          setLinkCertificado(res.data.certificado_path);
        }
      })
      .catch((err) => {
        setFileName('');
        setIdCertificado('');
        setSenhaCertificado('');
        setLinkCertificado(null);
      });
  };

  const handleAddFile = () => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={modalAddFile}
        onClose={() => setModalAddFile(false)}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: 5,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <DropZone
            handleButtonClick={(file) => {
              setModalAddFile(false);
              if (file) {
                setCertificado(file[0]);
                setFileName(file[0].name);
              }
            }}
          />
        </div>
      </Modal>
    );
  };

  return (
    <div
      style={{
        margin: 20,
      }}
    >
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
      />
      <Paper
        elevation={3}
        style={{
          marginBottom: 10,
          paddingTop: 20,
          paddingBottom: 20,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <h1
          style={{
            fontSize: 25,
            h1Align: 'center',
            fontWeight: 'bold',
            color: '#030d4f',
          }}
        >
          Empresa do Usuário
        </h1>
      </Paper>
      <Snackbar open={abrirAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert severity={tipoAlerta} onClose={handleClose}>
          {mensagemAlert}
        </Alert>
      </Snackbar>
      <Paper
        elevation={3}
        className={classes.root}
        style={{ marginBottom: 10, paddingLeft: 30 }}
      >
        <p style={{ fontSize: '15px' }}>Buscar empresa do usuário</p>
        <ListOfCompany
          label="Empresa do Cliente *"
          width="40%"
          companySelect={nomeEmpresa}
          setCompanySelect={(nome) => {
            setNomeEmpresa(nome);
          }}
          setIdEmpresa={(id) => setIdEmpresa(id)}
          setObjEmpresa={(obj) => fetchDataCompany(obj)}
          assinantes
        />
      </Paper>
      <Paper elevation={3} className={classes.root}>
        <p style={{ fontSize: '16px', paddingLeft: 7, paddingBottom: 15 }}>
          Dados da Empresa
        </p>
        <div
          style={{ display: 'flex', flexDirection: 'row', marginBottom: 15 }}
        >
          <TextField
            id="standard-full-width"
            label="Razão Social *"
            style={{ margin: 8, width: '60%' }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => setRazaoSocial(event.target.value)}
            value={razaoSocial}
            error={razaoSocialError}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
          <ListOfUsers
            arrayWithUsers={arrayWithUsers}
            setArrayWithUsers={setArrayWithUsers}
            label="Nome do Cliente *"
            width="40%"
            userSelect={nomeUsuario}
            setUserSelect={(user) => setNomeUsuario(user)}
            setIdUsuario={(id) => setIdUsuario(id)}
            error={idUsuarioError}
            readOnly={!hasEditAccess}
          />
        </div>
        <div
          style={{ display: 'flex', flexDirection: 'row', marginBottom: 15 }}
        >
          <TextField
            id="standard-full-width"
            label="CNPJ *"
            style={{ margin: 8, width: '70%' }}
            helperText={errorMessageCnpj}
            margin="normal"
            InputLabelProps={{
              shrink: true,
              className: classes.test,
            }}
            onChange={(event) => setCnpj(mask(event.target.value, CNPJPattern))}
            error={errorCnpj}
            value={cnpj}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
          <TextField
            id="standard-select-currency"
            select
            style={{ margin: 8, width: '15%' }}
            label="Tipo Empresa *"
            value={tipoEmpresa}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event, value) => {
              setTipoEmpresa(event.target.value);
              setIdTipoEmpresa(value.key.replace('.$', ''));

              if (event.target.value === 'MEI') {
                setTipoTributacao(event.target.value);
                setIdTipoTributacao(1);
              } else if (tipoTributacao === 'MEI') {
                setTipoTributacao('');
                setIdTipoTributacao('');
              }
            }}
            error={tipoEmpresaError}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          >
            {arrayTipoEmpresa.map((option) => (
              <MenuItem key={option.id} value={option.nome}>
                {option.nome}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="standard-select-currency"
            select
            style={{ margin: 8, width: '15%' }}
            label="Tipo Tributação *"
            value={tipoTributacao}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event, value) => {
              setTipoTributacao(event.target.value);
              setIdTipoTributacao(value.key.replace('.$', ''));

              if (event.target.value === 'MEI') {
                setTipoEmpresa(event.target.value);
                setIdTipoEmpresa(1);
              } else if (tipoEmpresa === 'MEI') {
                setTipoEmpresa('');
                setIdTipoEmpresa('');
              }
            }}
            error={tipoTributacaoError}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          >
            {arrayTipoTributacao.map((option) => (
              <MenuItem key={option.id} value={option.nome}>
                {option.nome}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div
          style={{ display: 'flex', flexDirection: 'row', marginBottom: 15 }}
        >
          <TextField
            id="standard-full-width"
            label="CEP *"
            style={{ margin: 8, width: '20%' }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setCep(mask(event.target.value, CEPPattern));
              if (event.target.value.length === 10) {
                handleCEP(event.target.value);
              }
            }}
            error={cepError}
            value={cep}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
          <TextField
            id="standard-full-width"
            label="Logradouro *"
            style={{ margin: 8, width: '45%' }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setLogradouro(event.target.value);
            }}
            error={logradouroError}
            value={logradouro}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
          <TextField
            id="standard-full-width"
            label="Cidade *"
            style={{ margin: 8, width: '20%' }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setCidade(event.target.value);
            }}
            error={cidadeError}
            value={cidade}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
          <TextField
            id="standard-select-currency"
            select
            style={{ margin: 8, width: '15%' }}
            label="Estado *"
            value={estado}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => setEstado(event.target.value)}
            error={estadoError}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          >
            {UFS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div
          style={{ display: 'flex', flexDirection: 'row', marginBottom: 15 }}
        >
          <TextField
            id="standard-full-width"
            label="Complemento *"
            style={{ margin: 8, width: '55%' }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setComplemento(event.target.value);
            }}
            error={complementoError}
            value={complemento}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
          <TextField
            id="standard-full-width"
            label="Bairro *"
            style={{ margin: 8, width: '30%' }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setBairro(event.target.value);
            }}
            error={bairroError}
            value={bairro}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
          <TextField
            id="standard-full-width"
            label="Número *"
            style={{ margin: 8, width: '15%' }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setNumero(event.target.value);
            }}
            error={numeroError}
            value={numero}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
        </div>
        <div
          style={{ display: 'flex', flexDirection: 'row', marginBottom: 15 }}
        >
          <TextField
            id="standard-full-width"
            helperText={messageCNAE}
            label="CNAE *"
            style={{ margin: 8, width: '50%' }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setCNAE(mask(event.target.value, cnaePattern));
            }}
            error={cnaeError}
            value={cnae}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
          <TextField
            id="standard-full-width"
            label="Código Simples"
            style={{ margin: 8, width: '50%' }}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setCodigoSimples(event.target.value);
            }}
            error={false}
            value={codigoSimples}
            InputProps={{
              readOnly: !hasEditAccess,
            }}
          />
        </div>
      </Paper>
      {hasEditAccess ? (
        <>
          <Paper
            elevation={3}
            className={classes.root}
            style={{ marginBottom: 10, paddingLeft: 30, marginTop: 10 }}
          >
            <p style={{ fontSize: '15px', fontWeight: 'normal' }}>
              Certificado Digital do Usuário
            </p>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  marginTop: 5,
                  width: 'auto',
                  marginRight: 15,
                }}
              >
                <p
                  style={{
                    fontSize: '13px',
                    fontWeight: 'normal',
                    marginBottom: 5,
                  }}
                >
                  Upload do Certificado
                </p>
                <Button
                  startIcon={<CloudUploadIcon />}
                  fullWidth
                  size="small"
                  variant="contained"
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                  }}
                  onClick={() => setModalAddFile(true)}
                >
                  {fileName || 'Enviar'}
                </Button>
              </div>
              <TextField
                id="standard-full-width"
                label="Senha"
                type="password"
                style={{
                  margin: 8,
                  width: '50%',
                  marginTop: fileName ? 10 : 8,
                }}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => {
                  setSenhaCertificado(event.target.value);
                }}
                error={false}
                value={senhaCertificado}
              />
              <Collapse in={linkCertificado}>
                <div
                  style={{
                    marginTop: 5,
                    width: 'auto',
                    marginRight: 15,
                    marginLeft: 115,
                  }}
                >
                  <p
                    style={{
                      fontSize: '13px',
                      fontWeight: 'normal',
                      marginBottom: 5,
                    }}
                  >
                    Download do Certificado
                  </p>
                  <Button
                    startIcon={<CloudDownloadIcon />}
                    fullWidth
                    size="small"
                    variant="contained"
                    style={{
                      backgroundColor: XMEI_PRIMARY_COLOR,
                      color: '#FFF',
                    }}
                    href={linkCertificado}
                    target="_blank"
                  >
                    Download
                  </Button>
                </div>
              </Collapse>
            </div>
            {handleAddFile()}
          </Paper>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              variant="contained"
              style={{
                backgroundColor: XMEI_PRIMARY_COLOR,
                color: '#FFF',
              }}
              onClick={() => handleSubmit()}
            >
              FINALIZAR
            </Button>
          </div>
        </>
      ) : null}
    </div>
  );
}
